import { Observable, Subject } from 'rxjs';
import { ItemType } from '../models/item.model';
import { MapItem } from '../models/weavix-map.model';
import { PermissionAction } from '../permissions/permissions.model';
import { AlertMaydayService } from './alert-mayday.service';
import { ProfileService } from './profile.service';
import { StateServiceBase, StateUpdate } from './state-base.service';
import { FacilityAlertItem } from '@weavix/models/src/alert/facility-alerts';

export class AlertStateService extends StateServiceBase {
    alerts: Observable<FacilityAlertItem[]>;
    itemTypes = new Map<string, ItemType>();

    items$ = new Subject<StateUpdate<MapItem>>();
    itemTypes$ = new Subject<StateUpdate<ItemType>>();

    constructor(
        private readonly alertMaydayService: AlertMaydayService,
        private readonly profileService: ProfileService,
    ) {
        super();
    }

    async loadData(c: any, accountId: string, facilityId?: string, tags?: string[]) {
        if (!this.profileService.hasPermission(PermissionAction.ViewSites, facilityId)) return;
        this.alerts = this.alertMaydayService.alerts;
    }

    async stop() {
        super.stop();
    }

    protected async setupSubscriptions(c: any, accountId: string, facilityId?: string) {
        return [
            // this.profileService.hasAnyPermission(PermissionTarget.Items, Permission.Read, facilityId)
            //     && (await this.alertMaydayService.subscribeUpdates(c)).subscribe(async (result) => {
            //         if (result.payload.items) {
            //             const itemMap = result.payload.items;
            //             const filtered = {};
            //             Object.keys(itemMap).forEach(id => {
            //                 if (!itemMap[id] || this.profileService.hasPermission(PermissionTarget.Items, Permission.Read, facilityId, itemMap[id].folderId)) {
            //                     filtered[id] = itemMap[id];
            //                 }
            //             });
            //             this.updateFromMap(this.alerts, filtered, this.alerts$);
            //         } else if (result.payload.itemTypes) {
            //             const itemTypeMap = result.payload.itemTypes;
            //             this.updateFromMap(this.itemTypes, itemTypeMap, this.itemTypes$);
            //         }
            //     }),
        ];
    }
}
